import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '../../../assets/scss/onboarding.css';

const OnboardingModal = ({
  isVisible, handleContinue, buttonText, children, finishModal, history
}) => {
  const exitGuidedTour = () => {
    history.push('/');
  }

  return (
    <Modal
      className='onboarding-modal'
      visible={isVisible}
    >
      <div className="modal-header">
        <a
          onClick={(e) => { e.preventDefault(); handleContinue(); }}
          className="close-onboarding-modal"
        >
          <FontAwesomeIcon icon="times" />
        </a>
      </div>
      <div className="modal-body">
        {children}
      </div>
      <div className="modal-footer p-0">
        {!finishModal && (<button
          type="button"
          className="btn btn-transparent text-muted w-100 pl-5 p-3 btn-modal-left"
          onClick={exitGuidedTour}
        >
          Quit Guided Tour
        </button>)}
        <button
          type="button"
          className={`btn btn-warning w-100 text-white pl-5 p-3 btn-modal-right ${finishModal && "onboarding-full-width-btn"}`}
          onClick={handleContinue}
        >
          {buttonText}
          <span>
            <FontAwesomeIcon icon="arrow-right" />
          </span>
        </button>
      </div>
    </Modal>
  );
};

OnboardingModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleRemoveOnboardingModal: PropTypes.func
};

export default withRouter(OnboardingModal);



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modal/index.js